import { bdCommonTrack } from '@/utils/bdCourier'

/* 装饰器工厂 */
type iHandler = (
  params,
  originMethod?: any,
  scope?: any,
  DecoratorsParams?: any,
  methodName?: any
) => any

/* 装饰器工厂- 默认： 只注入写函数体 */
const FactoryDecorators = (handler: iHandler) => {
  return (DecoratorsParams?: any) => {
    return (target, methodName: string, descriptor: PropertyDescriptor) => {
      const originMethod = descriptor.value
      descriptor.value = function (...params: any[]) {
        handler(params, originMethod, this, DecoratorsParams, methodName)
      }
    }
  }
}

/* 北斗统计 */
export const bdLog = FactoryDecorators(
  async (params, originMethod, scope, DecoratorsParams) => {
    bdCommonTrack(DecoratorsParams.name, DecoratorsParams.params)
    originMethod.apply(scope, params)
  }
)

export default FactoryDecorators
